import { render } from "./Perf.vue?vue&type=template&id=049f280d"
import script from "./Perf.vue?vue&type=script&lang=js"
export * from "./Perf.vue?vue&type=script&lang=js"

import exportComponent from "/home/welchome/public_html/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__